import React from 'react';
import { RouteConfig } from 'react-router-config';

import { PageRouteType, routePostProc } from '@/util/route';

// 复用operate的aiReplyList页面
const AiReplyList = React.lazy(
  () => import('@/page/app/operate/ai-reply-list/keepAlive')
);

// 复用operate的aiServiceConfig页面
const AiServiceConfig = React.lazy(
  () => import('@/page/app/operate/aisee-config-entry/config/ai-service-config')
);
// 转人工工单列表
// const WorkOrderList = React.lazy(
//   () => import('@/page/app/ai-servant/work-order-list/keepAlive')
// );

// const AiseeDetail = React.lazy(() => import('@/page/app/operate/aisee-detail'));
// TODO 在此补充【数据概览】入口

const AI_SERVANT_ROUTE: RouteConfig[] = [
  {
    path: '/aiReplyList',
    component: AiReplyList,
  },
  {
    path: '/aiServiceConfig',
    component: AiServiceConfig,
  },
  // {
  //   path: '/workOrderList',
  //   component: WorkOrderList,
  // },
  // {
  //   path: '/workOrderDetail',
  //   component: AiseeDetail,
  // },
];

export { AI_SERVANT_ROUTE };
export default routePostProc(PageRouteType.AI_SERVANT, AI_SERVANT_ROUTE);
